import React from 'react'
import './experience.css';
import { FaCss3, FaFigma, FaHtml5, FaJs } from "react-icons/fa";
import { SiRadstudio } from "react-icons/si";
import { FaGoogle } from "react-icons/fa";
import { SiMongodb } from "react-icons/si";
import { RiNetflixFill } from "react-icons/ri";
import { FaAmazon } from "react-icons/fa";
import { FaReact } from "react-icons/fa";
import Eumimage from "../Myimages/EUMuni logo.png"
import Corvitimage from "../Myimages/corvit logo.png"
import Htmlimage from "../Myimages/Html logo.png"
export default function experience() {
   const Details = [
      {
         "Heading": "Computer Scientist",
         "Subheading": "Sept 2023 - Present",
         "img": Eumimage,
         "points": ["OOP", "DSA", "Database"]
      },
      {
         "Heading": "Frontend Intern (Corvit)",
         "Subheading": "June 2025 - August 2025",
         "img": Corvitimage,
         "points": ["React", "Tailwind", "Javascript"]
      },
      {
         "Heading": "Personal Developemnt",
         "Subheading": "Jan 2025 - Present",
         "img": Htmlimage,
         "points": ["HTML", "CSS", "JS"]
      }
   ]
   return (
      <div>
         <div id='Experience' className=' px-32 pt-4'>
            <h1 className='main-heading text-4xl font-bold text-white'>
               Experience
            </h1>
            <div className='flex flex-wrap justify-around items-center'>
               <div className='logos flex flex-wrap w-1/3 gap-20 py-6'>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <FaHtml5 className='size-14' color="#e34c26" />
                  </span>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <FaCss3 className='size-14' color="#264de4" />
                  </span>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <SiMongodb className='size-14' color="#47A248" />
                  </span>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <FaGoogle className='size-14' color="#2865b4" />
                  </span>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <SiRadstudio className='size-14' color="#E60028" />
                  </span>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <RiNetflixFill className='size-14' color="#E50914" />
                  </span>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <FaAmazon className='size-14' color="#FF9900" />
                  </span>
                  <span className='bg-[var(--card-bg)] flex items-center rounded-2xl p-3' >
                     <FaReact className='size-14' color="#FF9900" />
                  </span>
               </div>
               <div className='py-12 flex flex-col items-center justify-center'>
                  <div className='flex flex-col '>
                     
                        {
                     Details.map(detail => (
                        <div className='box flex gap-10 items-center p-6 px-12 bg-[var(--card-bg)] rounded-xl bg-opacity-45  mb-6 '>
                           <img className='img size-24' color='#2865b4' src={detail.img} alt="Eum logo" />
                           <span className='text-white'>
                              <h2 className='leading-tight text-2xl py-2'>
                                 {detail.Heading}
                              </h2>
                              <p className='text-lg leading-tight font-thin mb-2'>
                                 {detail.Subheading}
                              </p>
                                 {detail.points.map(point => (
                                    <>
                                       <li className='text-sm p-2'>{point}</li>
                                    </>
                                 ))}
                           </span>
                        </div>
                     ))
                        }
                  </div>
                 
            </div>

            </div>

         </div>

      </div>
   )
}
